export default "__VITE_ASSET__DzPNSVeq__"